<template>
  <v-container fluid class="text-center">
    <v-progress-circular
      v-if="loading"
      :size="80"
      :width="7"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ViewResource",
  data: () => ({
    loading: true
  }),
  computed: mapGetters({}),
  created() {
    this.$store
      .dispatch("resource/getResource", this.$route.params.id)
      .then(url => {
        window.location.href = url;
      });
  }
};
</script>
